import { getReferrerAttribution } from "@outschool/attribution";
import { Box } from "@outschool/backpack";
import { faFacebook } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { FacebookButton } from "@outschool/ui-components-shared";
import { Icon } from "@outschool/ui-legacy-component-library";
import { useNavigation } from "@outschool/ui-utils";
import React from "react";

import * as Routes from "../../Routes";

type ContinueWithFacebookProps = {
  isLearnerApp?: boolean;
  setAuthStrategy: (strategy: "facebook") => void;
  trackingName: string;
  getAnonymousId?: () => Promise<string | null>;
};

export default function ContinueWithFacebook({
  isLearnerApp,
  setAuthStrategy,
  trackingName,
  getAnonymousId = () => Promise.resolve(null)
}: ContinueWithFacebookProps) {
  const { t } = useTranslation(
    "shared\\components\\facebook\\ContinueWithFacebook"
  );
  const navigate = useNavigation();
  const onClick = async () => {
    setAuthStrategy("facebook");
    const anonymousId = await getAnonymousId();
    const redirectUri = Routes.facebookAuthRedirectUrl(isLearnerApp);
    const loginRedirectRoute = Routes.facebookAuthUrl(redirectUri, {
      ...getReferrerAttribution(),
      anonymousId
    });
    // See http://caniuse.com/#feat=referrer-policy
    if (window && window.document) {
      const meta = window.document.createElement("meta");
      meta.setAttribute("name", "referrer");
      meta.setAttribute("content", "never");
      window.document.head.appendChild(meta);
    }
    // perform redirect
    navigate(loginRedirectRoute, { hardNav: true });
  };

  return (
    <FacebookButton
      onClick={onClick}
      trackingName={trackingName}
      sx={{ padding: "0 !important", display: "flex" }}
    >
      <Box
        sx={{
          fontSize: "1.5em",
          padding: "10px",
          width: "44px"
        }}
      >
        <Icon icon={faFacebook} sx={{ display: "block" }} />
      </Box>
      <Box
        sx={{
          flex: 1,
          padding: "12.5px",
          minWidth: "215px"
        }}
      >
        {t`Continue with Facebook`}
      </Box>
    </FacebookButton>
  );
}
